import { getRequest } from '@/core';
import { customers } from '@/requests';

export default async function getCustomerByNumberRequest(number) {
	let url = customers.getByNumberPath(number);
	return getRequest(url);
}
